<template>
  <div class="box">
    <div ref="chart" class="chart" :style="{ height: `${height}px` }"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    option: Object,
    onLoad: Function,
    height: {
      type: Number,
      default: 280
    }
  },
  created() { },
  mounted() {
    this.init();
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    init() {
      const chart = echarts.init(this.$refs.chart);
      this.chart = chart;
      if (this.option) {
        chart.setOption(this.option);
      }
      if (this.onLoad) {
        this.onLoad(chart);
      }
      this.$nextTick(() => {
        chart.resize();
      });
    },

    setOption(option, notMerge = false, lazyUpdate = false) {
      if (!this.chart) {
        return;
      }
      if (notMerge) {
        this.chart.setOption(option, true, lazyUpdate);
      } else {
        const newOpt = { ...this.option, ...option };
        this.chart.setOption(newOpt, false, lazyUpdate);
      }
      this.$nextTick(() => {
        this.chart.resize();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  background: #fff;
  position: relative;
  width: 100%;

  .chart {
    width: 100%;
  }
}
</style>
